var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_705_5833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.723694 10.1315C0.723694 11.367 0.967036 12.5904 1.43983 13.7318C1.91262 14.8732 2.6056 15.9103 3.4792 16.7839C4.35281 17.6575 5.38992 18.3505 6.53134 18.8233C7.67276 19.2961 8.89613 19.5394 10.1316 19.5394C11.3671 19.5394 12.5904 19.2961 13.7318 18.8233C14.8733 18.3505 15.9104 17.6575 16.784 16.7839C17.6576 15.9103 18.3506 14.8732 18.8234 13.7318C19.2961 12.5904 19.5395 11.367 19.5395 10.1315C19.5395 8.89607 19.2961 7.6727 18.8234 6.53128C18.3506 5.38986 17.6576 4.35275 16.784 3.47914C15.9104 2.60554 14.8733 1.91256 13.7318 1.43977C12.5904 0.966975 11.3671 0.723633 10.1316 0.723633C8.89613 0.723633 7.67276 0.966975 6.53134 1.43977C5.38992 1.91256 4.35281 2.60554 3.4792 3.47914C2.6056 4.35275 1.91262 5.38986 1.43983 6.53128C0.967036 7.6727 0.723694 8.89607 0.723694 10.1315Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 8.31761C6.875 8.74527 6.95923 9.16875 7.12289 9.56385C7.28655 9.95896 7.52643 10.318 7.82883 10.6204C8.13123 10.9228 8.49023 11.1626 8.88534 11.3263C9.28045 11.49 9.70392 11.5742 10.1316 11.5742C10.5592 11.5742 10.9827 11.49 11.3778 11.3263C11.7729 11.1626 12.1319 10.9228 12.4343 10.6204C12.7367 10.318 12.9766 9.95896 13.1403 9.56385C13.3039 9.16875 13.3882 8.74527 13.3882 8.31761C13.3882 7.88995 13.3039 7.46648 13.1403 7.07138C12.9766 6.67627 12.7367 6.31727 12.4343 6.01487C12.1319 5.71246 11.7729 5.47259 11.3778 5.30893C10.9827 5.14527 10.5592 5.06104 10.1316 5.06104C9.70392 5.06104 9.28045 5.14527 8.88534 5.30893C8.49023 5.47259 8.13123 5.71246 7.82883 6.01487C7.52643 6.31727 7.28655 6.67627 7.12289 7.07138C6.95923 7.46648 6.875 7.88995 6.875 8.31761Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4737 14.9504C13.925 14.3432 13.2551 13.8578 12.5072 13.5256C11.7593 13.1934 10.95 13.0217 10.1316 13.0217C9.31322 13.0217 8.50394 13.1934 7.75602 13.5256C7.0081 13.8578 6.33817 14.3432 5.78949 14.9504",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_5833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.b7b069efafb6218f0ee9487a5acd1b4f.svg";
export { ForwardRef as ReactComponent };